import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import LoginWithLink from './views/LoginWithLink.vue'
import PasswordRecovery from './views/PasswordRecovery.vue'
import AdminPartners from './views/admin/AdminPartners.vue'
import AdminClients from './views/admin/AdminClients.vue'
import PartnerValidate from './views/partner/PartnerValidate.vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import database from "@/services/database";

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/linklogin',
      name: 'LoginWithLink',
      component: LoginWithLink
    },
    {
      path: '/recover',
      name: 'PasswordRecovery',
      component: PasswordRecovery
    },
    {
      path: '/admin/partners',
      name: 'AdminPartners',
      component: AdminPartners,
      meta: {
        requiresAuth: true,
        requiresRole: 'admin'
      }
    },
    {
      path: '/admin/clients',
      name: 'AdminClients',
      component: AdminClients,
      meta: {
        requiresAuth: true,
        requiresRole: 'admin'
      }
    },
    {
      path: '/partner/validate',
      name: 'PartnerValidate',
      component: PartnerValidate,
      meta: {
        requiresAuth: true,
        requiresRole: 'partner'
      }
    }

  ]
});

router.beforeEach(async (to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(route => route.meta.requiresAuth);
  const requiresRole = to.matched[0].meta.requiresRole;

  //let user;
  let userRole;
  if (currentUser) {
    let snapshot = await database
      .collection("users")
      .where("email", "==", currentUser.email)
      .get();

    if (snapshot.size == 1) {
      userRole = snapshot.docs[0].data().role;
    }

    if (userRole == "admin" && to.path == "/login") {
      next('/admin/partners');
    } else if (userRole == "partner" && to.path == "/login") {
      next('/partner/validate');
    }
  }

  if (requiresAuth && !currentUser) next('login');
  else if (requiresAuth && requiresRole && requiresRole !== userRole) next('login')
  else next();
});

export default router;